import Icon from '../components/Icon.vue'

Icon.register({"deviantart":{"width":1024,"height":1792,"paths":[{"d":"M1024 303l-303 582 24 31h279v415h-507l-44 30-142 273-30 30h-301v-303l303-583-24-30h-279v-415h507l44-30 142-273 30-30h301v303z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/deviantart.js
// module id = 496
// module chunks = 0